import X from 'icons/indexed-icons/X';
import React from 'react';
import styled from 'styled-components';
import theme from 'themes';

interface TabProps {
  selected?: boolean;
  disabled?: boolean;
  variant?: 'outlined' | 'filled';
}

interface Props extends TabProps, React.HTMLAttributes<HTMLButtonElement> {
  children?: string | React.ReactNode;
  count?: number | string;
  icon?: React.ReactNode;
  variant?: 'outlined' | 'filled';
  isShowCross?: boolean;
}

const Container = styled.span<TabProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  padding: 0.6875rem;
  background-color: ${({ theme, variant }) =>
    variant === 'filled' ? theme.colors.primaryBlue5 : 'white'};
  color: ${({ theme, variant }) =>
    variant === 'filled' ? theme.colors.white : theme.colors.textLightBlack};
  border: 1px solid;
  border-radius: 1.25rem;
  border-color: ${({ theme }) => theme.colors.primaryBlue5};

  .icon--x {
    margin-top: 0.22rem;
    height: 12px;
    width: 12px;
    path {
      stroke: ${({ theme, selected }) =>
        selected ? theme.colors.white : theme.colors.textLightBlack};
    }
  }

  ${({ variant, theme, disabled, selected }) =>
    variant === 'filled' &&
    `
    background-color:${selected ? theme.colors.darkBlue1 : theme.colors.primaryBlue5};
    color:${theme.colors.white};
    border-color:${theme.colors.darkBlue1};
     .icon--x {
        path {
          stroke: ${theme.colors.white};
        }
      }

    :hover {
      background-color: ${!disabled && !selected && theme.colors.darkBlue1};
    }
  `}

  ${({ variant, theme, disabled, selected }) =>
    variant === 'outlined' &&
    `
    background-color:${selected ? theme.colors.darkBlue2 : theme.colors.white};
    color:${selected ? theme.colors.white : theme.colors.textLightBlack};
    border-color:${selected ? theme.colors.darkBlue2 : theme.colors.primaryBlue5};
    :hover {
      background: ${!disabled && !selected && theme.colors.info300};
    }
  `}
`;

const Count = styled.span`
  :hover {
    color: ${theme.colors.white};
  }
`;

const Pill = ({
  variant = 'outlined',
  icon,
  children,
  count,
  selected,
  disabled,
  isShowCross = false,
  ...rest
}: Props): JSX.Element => (
  <Container
    as="button"
    role="button"
    variant={variant}
    selected={selected}
    disabled={disabled}
    {...rest}
  >
    {icon ? <span className="icon">{icon}</span> : null}
    {children}
    {count !== undefined && count !== null && <Count>({count})</Count>}
    {isShowCross && (
      <span className="cross">
        <X />
      </span>
    )}
  </Container>
);

export default Pill;